import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import SubmitPrayer from "@/pages/SubmitPrayer";
import Vigil from "@/pages/Vigil";
import MyPrayerList from "@/pages/MyPrayerList";
import { MorningPrayer, EveningPrayer } from "@/pages/Devotion";
import AnsweredRegister from "@/pages/AnsweredRegister";
import { StillBeingHeld, WordsForTheWay, OurPractice, About, Practices, Policies } from "@/pages/Content";
import { Login, Register } from "@/pages/Auth";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Account from "@/pages/Account";

import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminNewPrayers from "@/admin/AdminNewPrayers";
import AdminPrayerCircle from "@/admin/AdminPrayerCircle";
import AdminMondayVigil from "@/admin/AdminMondayVigil";
import AdminQuotes from "@/admin/AdminQuotes";
import { AdminAnswered, AdminUpdates, AdminPeople } from "@/admin/AdminMisc";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Admin (no public layout) */}
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="new" element={<AdminNewPrayers />} />
            <Route path="circle" element={<AdminPrayerCircle />} />
            <Route path="vigil" element={<AdminMondayVigil />} />
            <Route path="answered" element={<AdminAnswered />} />
            <Route path="updates" element={<AdminUpdates />} />
            <Route path="people" element={<AdminPeople />} />
            <Route path="words" element={<AdminQuotes />} />
          </Route>

          {/* Public */}
          <Route path="/" element={withLayout(<Home />)} />
          <Route path="/submit" element={withLayout(<SubmitPrayer />)} />
          <Route path="/vigil" element={withLayout(<Vigil />)} />
          <Route path="/answered" element={withLayout(<AnsweredRegister />)} />
          <Route path="/still-being-held" element={withLayout(<StillBeingHeld />)} />
          <Route path="/words" element={withLayout(<WordsForTheWay />)} />
          <Route path="/our-practice" element={withLayout(<OurPractice />)} />
          <Route path="/practices" element={withLayout(<Practices />)} />
          <Route path="/about" element={withLayout(<About />)} />
          <Route path="/policies" element={withLayout(<Policies />)} />
          <Route path="/login" element={withLayout(<Login />)} />
          <Route path="/register" element={withLayout(<Register />)} />
          <Route path="/forgot-password" element={withLayout(<ForgotPassword />)} />
          <Route path="/reset-password" element={withLayout(<ResetPassword />)} />

          {/* Member */}
          <Route path="/my-list" element={<ProtectedRoute>{withLayout(<MyPrayerList />)}</ProtectedRoute>} />
          <Route path="/morning" element={<ProtectedRoute>{withLayout(<MorningPrayer />)}</ProtectedRoute>} />
          <Route path="/evening" element={<ProtectedRoute>{withLayout(<EveningPrayer />)}</ProtectedRoute>} />
          <Route path="/account" element={<ProtectedRoute>{withLayout(<Account />)}</ProtectedRoute>} />
        </Routes>
        <Toaster position="bottom-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
